module.exports = __webpack_public_path__ + "assets/media/2.6d4c1076.wav";